<template lang="pug">

  a( :href="lang_en['site-check-rating-url']" target="_blank" ).solid-btn
    .bg(ref="bg")
    .inner 
      p {{ copy }}

</template>

<script>

import gsap from 'gsap'
import { mapState, mapMutations } from 'vuex' 
import { MODAL_STATES, PATHS } from 'src/config/app'
import CloseSvg from 'src/assets/svgs/close.svg'

export default { 

  props: {
    copy: String,
    theme: String 
  },

  mounted(){ 
    this.$el.classList.toggle('dark', this.theme === 'dark')
  },

  computed: {},

  components: {
    CloseSvg
  },

  methods: {
  

  }
}

</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"
 

.solid-btn
  color: #282B60 
  height: 64px
  min-width: 150px
  display: inline-block
  position: relative
  outline: none

  &:hover,
  &:focus
    .bg
      transition: transform 0.1s ease-out, opacity 0.1s ease-out
      // opacity: 0.92
      border: 2px solid rgba(40, 43, 96, 0.3)
      transform: scale(1.1) 

    &.dark
      color: #282B60 

      .bg
        background: white 


  .bg
    transform: scale(1) 
    transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out
    opacity: 1
    position: absolute
    top: 0
    height: 100%
    width: 100%
    background: white
    border-radius: 32px 
    border: none


  &.dark
    color: white 

    .bg
      background: #373C85 


  .inner
    position: relative
    width: 100%
    height: 100%
    display: flex
    align-items: center
    justify-content: center
    padding: 0 3.8rem

    p
      white-space: nowrap
      font-family: "Regular" 
      font-size: 1.5rem


</style>
